module.exports = __webpack_public_path__ + "files/logo_sn_cz.svg";